var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhite6Inline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 83,
  viewBox: "0 0 60 83",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M59.541.2c-.1-.1-.3-.2-.5-.2H.641c-.2 0-.4.1-.5.2-.1.2-.2.4-.1.6l9.8 59.3c.1.3.3.6.7.6h12l.8 9.7h-5.1l11.8 11.8 11.8-11.8h-5.1l.8-9.6h12.2c.3 0 .6-.2.7-.6l9.2-59.3c.1-.4 0-.6-.1-.7Zm-22.5 47.5s-2.7 2.7-7 2.4c-4.3.3-7-2.4-7-2.4-4.4-4.4-2.8-9.8-1.3-12.6.9-1.8 7.7-11.9 8.2-12.7v-.1.1c.6.9 7.3 11 8.2 12.7 1.7 2.8 3.2 8.2-1.1 12.6Zm18.5-35c-1.6-.7-3.6-.4-5.5.3-7.2 2.9-12.2 4-19.8 1.6-4.8-1.5-9.3-4.6-14.6-2.7-3.5 1.3-6.8 2.5-10.8 2.4l-2.3-11.8h54.6l-1.6 10.2Z",
  fill: "#FFF",
  fillRule: "nonzero"
})));
export default SvgWhite6Inline;